// obtain plugin
var cc = initCookieConsent();

// run plugin with your configuration
cc.run({
    current_lang: 'cs',
    autoclear_cookies: true,                   // default: false
    page_scripts: true,                        // default: false

    // mode: 'opt-in'                          // default: 'opt-in'; value: 'opt-in' or 'opt-out'
    delay: 5,                               // default: 0
    // autorun: true,                          // default: true
    // force_consent: false,                   // default: false
    // hide_from_bots: false,                  // default: false
    // remove_cookie_tables: false             // default: false
    // cookie_name: 'cc_cookie',               // default: 'cc_cookie'
    // cookie_expiration: 182,                 // default: 182 (days)
    // cookie_necessary_only_expiration: 182   // default: disabled
    // cookie_domain: location.hostname,       // default: current domain
    // cookie_path: '/',                       // default: root
    // cookie_same_site: 'Lax',                // default: 'Lax'
    // use_rfc_cookie: false,                  // default: false
    revision: 1645462292,                            // default: 0
    page_scripts: true,

    languages: {
        'cs': {
            consent_modal: {
                title: 'Používáme Cookies',
                description: 'Pro zkvalitnění našich služeb používáme cookies soubory. <button type="button" data-cc="c-settings" class="cc-link">Vyberte si z možností</button>',
                primary_btn: {
                    text: 'Akceptovat vše',
                    role: 'accept_all'              // 'accept_selected' or 'accept_all'
                },
                secondary_btn: {
                    text: 'Odmítnout vše',
                    role: 'accept_necessary'        // 'settings' or 'accept_necessary'
                }
            },
            settings_modal: {
                title: 'Nastavení Cookies',
                save_settings_btn: 'Uložit',
                accept_all_btn: 'Akceptovat vše',
                reject_all_btn: 'Odmítnout vše',
                close_btn_label: 'Zavřít',
                cookie_table_headers: [
                    {col1: 'Název'},
                    {col2: 'Doména'},
                    {col3: 'Expirace'}
                ],
                blocks: [
                    {
                        title: 'Informace o Cookies na stránkách Infina.cz',
                        description: 'Používáme Cookies pro zachování základní funkcionality na strankách a pro zkvalitnění poskytovaných služeb na základě interakce uživatele. Můžete si vybrat, které Cookies si přejete ukládat a nebo naopak úplně zakázat. Kompletní ustanovení ohledně Ochrany osobních údajů najdete <a href="/zpracovani-osobnich-udaju" target="_blank" class="cc-link">zde</a>.',
                    }, {
                        title: 'Striktně potřebné Cookies',
                        description: 'Tyto Cookies bohužel vypnout nemůžete, jelikož zajišťují základní funkcionalitu stránek a bez nich by stránky nefungovaly správně.',
                        toggle: {
                            value: 'necessary',
                            enabled: true,
                            readonly: true          // cookie categories with readonly=true are all treated as "necessary cookies"
                        },
                        cookie_table: [             // list of all expected cookies
                            {
                                col1: '_nss',
                                col2: 'infina.cz',
                                col3: 'Session'
                            },
                        ],
                    }, {
                        title: 'Analytické Cookies',
                        description: 'Pomocí těchto Cookies monitorujeme a ukládáme data o výkonnosti stránek.',
                        toggle: {
                            value: 'analytics',     // your cookie category
                            enabled: false,
                            readonly: false
                        },
                        cookie_table: [             // list of all expected cookies
                            {
                                col1: '^_ga',       // match all cookies starting with "_ga"
                                col2: 'google.com',
                                col3: '2 roky',
                                is_regex: true
                            },
                            {
                                col1: '_gid',
                                col2: 'google.com',
                                col3: '1 den',
                            },
                            {
                                col1: '_hj^',
                                col2: 'hotjar.com',
                                col3: '1 rok',
                                is_regex: true
                            }
                        ]
                    }, /*{
                        title: 'Reklamní a targetovací Cookies',
                        description: 'Tyto Cookies nám dovolí ukládat data o procházení stránek. Tyto data poté slouží k bližší analýze a následné optimalizaci stránek nebo služeb. Všechna data jsou plně anonymizována.',
                        toggle: {
                            value: 'targeting',
                            enabled: false,
                            readonly: false
                        }
                    }, */{
                        title: 'Další informace',
                        description: 'Pokud byste měli jakékoliv nejasnosti či připomínky ohledně používání Cookies na našich stránkách, prosím kontaktujte nás pomocí odkazu <a class="cc-link" target="_blank" href="/kontakt">zde</a>.',
                    }
                ]
            }
        }
    }
});